import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from './app.component';
import { FeatureModule } from "@app/features/feature.module";
import { ShareModule } from '@app/shared/shared.module';
import { KycService } from '@app/core/kyc.service';

@NgModule({
  exports: [AppComponent],
  declarations: [AppComponent],
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    ShareModule,
    FeatureModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([
        { path: '', loadChildren: './features/feature.module#FeatureModule' }
    ])
  ],
  providers: [
    KycService
  ]
})
export class AppModuleShared {}



// WEBPACK FOOTER //
// ./src/app/app.module.shared.ts